<ng-template #wizardContent>
    @if (config) {
        <div class="cerrix-wizard">
            @if (config.steps && config.allowPageChange) {
                <div class="wizard-steps">
                    @for (step of config.steps; track step; let i = $index) {
                        <div
                            class="wizard-step"
                            [attr.data-uiid]="'wizard-step-' + step.name"
                            [hidden]="step.hide"
                            [class.active]="i == config.activePageIndex"
                            (click)="changePageTo(i)"
                        >
                            @if (config.enableValidation) {
                                <i
                                    class="far validation"
                                    [class.fa-times-circle]="step.valid == false"
                                    [class.fa-dot-circle]="
                                        step.valid != false && step.valid != true
                                    "
                                    [class.fa-check-circle]="step.valid == true"
                                ></i>
                            }
                            <span class="step-icon text-truncate">
                                <i
                                    class="{{
                                        i <= config.activePageIndex ? 'fas' : 'far'
                                    }} fa-circle"
                                ></i>
                            </span>
                            <span class="step-name d-none d-lg-inline text-truncate">{{
                                step.name
                            }}</span>
                        </div>
                    }
                    @if (summaryEnabled) {
                        <div
                            class="wizard-step"
                            [class.active]="summaryIndex == config.activePageIndex"
                            (click)="changePageTo(config.steps.length)"
                        >
                            @if (config.enableValidation) {
                                <i class="fas fa-lock validation"></i>
                            }

                            <span class="step-icon text-truncate">
                                <i
                                    class="{{
                                        summaryIndex <= config.activePageIndex ? 'fas' : 'far'
                                    }} fa-circle"
                                ></i>
                            </span>
                            <span class="step-name d-none d-lg-inline text-truncate">{{ 'summaryStep' | t }}</span>
                        </div>
                    }
                </div>
            }

            <div
                class="wizard-pages"
                [class.summary]="summaryIndex == config.activePageIndex"
                [class.padded]="!config.noPagePadding"
            >
                @if (summaryEnabled) {
                    <div
                        class="wizard-page summary-section"
                        [hidden]="summaryIndex != config.activePageIndex"
                    >
                        @if (summaryTemplate) {
                            <ng-container [ngTemplateOutlet]="summaryTemplate"></ng-container>
                        }
                    </div>
                }
                @for (template of templates; track template; let i = $index) {
                    <div
                        class="wizard-page"
                        [hidden]="
                            config.activePageIndex != i && summaryIndex != config.activePageIndex
                        "
                    >
                        <ng-container [ngTemplateOutlet]="template"></ng-container>
                    </div>
                }
            </div>

            <div class="wizard-footer">
                @if (config.allowPageChange) {
                    <button
                        class="btn btn-dark"
                        data-uiid="wizard-button-previous"
                        (click)="changePageTo(config.activePageIndex - 1)"
                        [disabled]="config.activePageIndex <= 0"
                    >
                        <i class="fas fa-long-arrow-alt-left me-2"></i>
                        {{ 'previous' | t }}
                    </button>
                }

                @if (config.showInModal && config.useDedicatedClose) {
                    <button
                        class="btn btn-outline-danger right-button ms-2"
                        data-uiid="wizard-button-close"
                        (click)="closeWizard()"
                    >
                        {{ 'close' | t }}
                        <i class="fas fa-times ms-2"></i>
                    </button>
                }
                @if (
                    config.allowPageChange &&
                    config.activePageIndex < templates.length - (summaryEnabled ? 0 : 1)
                ) {
                    <button
                        class="btn btn-light right-button"
                        data-uiid="wizard-button-next"
                        (click)="changePageTo(config.activePageIndex + 1)"
                    >
                        {{ 'next' | t }}
                        <i class="fas fa-long-arrow-alt-right ms-2"></i>
                    </button>
                }
                @if (config.activePageIndex === templates.length - (summaryEnabled ? 0 : 1)) {
                    <button
                        class="btn btn-cerrix right-button"
                        data-uiid="wizard-button-complete"
                        (click)="complete()"
                        [disabled]="!config.completable || completeCallRunning"
                    >
                        {{ 'complete' | t }}
                        @if (completeCallRunning) {
                            <i class="fas fa-circle-notch fa-spin ms-2"></i>
                        } @else {
                            <i class="fas fa-check ms-2"></i>
                        }
                    </button>
                }

                @for (btn of config.buttons; track btn) {
                    <button
                        (click)="btn.click()"
                        [hidden]="btn.showOnPage != config.activePageIndex"
                        class="btn btn-light {{ btn.alignRight ? 'right-button me-2' : 'ms-2' }}"
                        [attr.data-uiid]="'wizard-button-' + btn.text"
                    >
                        @if (btn.icon && !btn.alignRight) {
                            <i [class]="btn.icon + ' me-2'"></i>
                        }
                        {{ btn.text }}
                        @if (btn.icon && btn.alignRight) {
                            <i [class]="btn.icon + ' ms-2'"></i>
                        }
                    </button>
                }
            </div>
        </div>
    }
</ng-template>

@if (config.showInModal) {
    <div
        bsModal
        #wizardModal="bs-modal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        [config]="modalConfig"
    >
        <div class="modal-dialog wizard-modal-dialog">
            <div class="modal-content">
                <ng-container [ngTemplateOutlet]="wizardContent"></ng-container>
            </div>
        </div>
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="wizardContent"></ng-container>
}

@if (config.showModalOnComplete) {
    <div bsModal #completeModal="bs-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content wizard-complete-modal">
                <div class="modal-body">
                    <i class="far fa-check-circle green"></i>
                    @if (config.completeModalTitle) {
                        <h2>{{ config.completeModalTitle }}</h2>
                    }
                    @if (config.completeModalSubtitle) {
                        <p>
                            {{ config.completeModalSubtitle }}
                        </p>
                    }
                </div>
                <div class="modal-footer">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        @for (btn of config.completeModalButtons; track btn) {
                            <button type="button" class="btn btn-secondary" (click)="btn.click()">
                                @if (btn.icon) {
                                    <i [class]="btn.icon + ' me-2'"></i>
                                }
                                {{ btn.text }}
                            </button>
                        }
                    </div>
                    <button
                        type="button"
                        class="btn btn-cerrix"
                        data-bs-dismiss="modal"
                        (click)="closeCompleteModal()"
                    >
                        {{ 'close' | t }}
                    </button>
                </div>
            </div>
        </div>
    </div>
}
